// removed by extract-text-webpack-plugin
module.exports = {"year_option_wrapper":"year_option_wrapper__3dfgG","year_option_average":"year_option_average__2C8tE","form":"form__XPz23","year_option":"year_option__3rEfZ","year_option_label":"year_option_label__1F_0O","select_deselect_btns":"select_deselect_btns__TI4vS"};


//////////////////
// WEBPACK FOOTER
// ./routes/history-rainfall/style.scss
// module id = 8Gg2
// module chunks = 10